import { render, staticRenderFns } from "./FormTimetableDayWrapper.vue?vue&type=template&id=079831dc&scoped=true"
import script from "./FormTimetableDayWrapper.vue?vue&type=script&lang=js"
export * from "./FormTimetableDayWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079831dc",
  null
  
)

export default component.exports